import Cookies from "js-cookie";
import { log } from "../utils/log_utils"
import apiClient from "../utils/api_client"

const WORKER_API_URL = process.env.REACT_APP_WORKER_API_URL || "http://localhost:8787"

export const handleLogin = async (redirectUrl) => {
    try {
      window.location.href = `${WORKER_API_URL}/auth/login?cache_bust=${Date.now()}&redirect=${redirectUrl}`;
      // const response = await fetch(`${WORKER_API_URL}/auth/login`, {
      //   method: 'GET',
      //   mode: "cors"
      // });
      // console.log(response)
      // if (response.redirected) {
      //   window.location.href = response.url;
      // }
    } catch (err) {
      console.error('Login failed:', err);
    }
  };



export const handleLogout = async () => {
  try {
    return await apiClient('/auth/logout', {
      method: 'POST',
    });
  } catch (error) {
    console.error('Logout failed:', error);
  }
};

export const getUser = async () =>{
  try {
    const result = await apiClient('/user', {
      method: 'GET',
    })
    if (!result) return { success: false, resp: "Unauthorized" }
    const { success, resp } = result
    if(success){
      const dbUser = {...resp, meta: JSON.parse(resp?.meta)}
      log("setting cookie user",dbUser,'getUser')
      Cookies.set("user",JSON.stringify(dbUser))
      return { success, resp: dbUser }
    }
    return { success: false, resp }
  } catch (error) {
    log("error getting user",error,'getUser')
    return { success: false, resp: error }
  }
}